import React from 'react';

const MissionStatement: React.FC = () => {
  return (
    <section className="mission-statement py-5">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="mb-5" style={{marginBottom: '50px'}}>
              <blockquote className="blockquote cs-lewis-quote">
                <p className="fs-3 fst-italic mb-2">
                  "Friendship is born at that moment when one person says to another:
                  'What? You, too? I thought I was the only one.'"
                </p>
                <p className="fs-5 text-end mt-2 mb-0">
                  — C.S. Lewis
                </p>
              </blockquote>
            </div>

            <div className="text-center" style={{marginTop: '50px'}}>
              <h2 className="display-4 fw-bold mb-4">
                Help Suicidal People Feel Less Alone
              </h2>
              <p className="lead mb-4">
                Your words of encouragement and hope are shared with people struggling
                with thoughts of suicide. These anonymous messages are displayed on screens
                in psychiatric wards and distributed in booklets to provide comfort and
                connection during their darkest moments.
              </p>
              <p className="lead">
                Every message matters. Every word of hope can save a life.
              </p>
            </div>
          </div>
        </div>

        {/* Informational Video */}
        <div className="row justify-content-center mt-5">
          <div className="col-lg-8">
            <div className="video-container">
              <video
                controls
                poster="/assets/images/2022_still01.png"
                className="w-100 rounded shadow"
                style={{ maxWidth: '100%' }}
              >
                <source src="/assets/videos/2202.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionStatement;
